(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/components/track-qr-code-failure.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/components/track-qr-code-failure.js');
"use strict";


const getShortNameByTicketId = ticketId => {
  let shortName;
  try {
    shortName = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(ticketId).shortName;
  } catch (e) {}
  return shortName;
};
const useTrackQRCodeFailure = ticketId => {
  React.useEffect(() => {
    const param = svs.utils.paramHandler.get({
      key: 'qr-code-invalid'
    });
    if (param.value === 'true') {
      const shortName = getShortNameByTicketId(ticketId);
      svs.ticketgames.ticketUtility.utils.tracking.trackValidateQRCodeFailure(shortName);
      svs.utils.paramHandler.remove({
        key: 'qr-code-invalid'
      });
    }
  }, [ticketId]);
};
const TrackQRCodeFailure = _ref => {
  let {
    ticketId
  } = _ref;
  useTrackQRCodeFailure(ticketId);
  return null;
};
setGlobal('svs.ticketsValidateManual.pages.home.components.TrackQRCodeFailure', TrackQRCodeFailure);

 })(window);